import { CollapsibleGroup } from '@platform/engine/menu/CollapsibleGroup';
import { useMenuOpenState } from '@platform/engine/menu/useMenuOpenState';
import { cx } from '@platform/core/lib/cx';
import { useAppSelector } from '@platform/state/hooks';
import { selectUi } from '@platform/state/selectors';
import type { ISystemMenuProps } from './ISystemMenuProps';
import { SystemMenuLink } from './SystemMenuLink';
import '@platform/engine/menu/menu.css';
import './systemMenu.css';

/**
 * Ліве меню системного модуля (прототип v4 G:L743–790, UIUX left-menu: «системні модулі мають свої меню»): назва 15px 700 і підзаголовок
 * 12px (рівень налаштування чи «Люди, доступ і платформа»), перемикач рівня «Робочий простір / Глобально» (лише «Налаштування»), «Огляд»
 * і розгортні групи з лічильниками; розгорнутість груп пам'ятається окремо для кожного меню.
 */
export function SystemMenu({ menuKey, title, sub, scope, groups }: ISystemMenuProps) {
  const openState = useMenuOpenState(menuKey);
  const collapsed = useAppSelector((s) => selectUi(s).leftMenuCollapsed);
  return (
    <aside className={cx('po-menu mnav', collapsed && 'is-collapsed')} aria-label={title}>
      <nav className="po-menu__nav mnav__nav" aria-label={title}>
        <div className="sm-head">
          <strong className="sm-head__title">{title}</strong>
          <span className="sm-head__sub" title={sub}>{sub}</span>
        </div>
        {scope}
        {groups.filter((g) => g.items.length).map((g) => (g.title
          ? (
            <CollapsibleGroup key={g.id} title={g.title} open={openState.isOpen(g.id, true)} onToggle={() => openState.toggle(g.id, true)}>
              {g.items.map((item) => <SystemMenuLink key={item.key} item={item} />)}
            </CollapsibleGroup>
          )
          : g.items.map((item) => <SystemMenuLink key={item.key} item={item} top />)))}
      </nav>
    </aside>
  );
}
